<template>
  <div>
    <p class="cm-mg-p-wzd">
      2. {{ $t('production.cause_rejected_clusters_info') }}
    </p>
    <hr />
    <div class="px-3">
      <div class="form-group has-label">
        <label
          >{{ $t('production.cause_rejected_clusters_number') }}:
          <strong>{{ model.rejected_quantity }}</strong></label
        >
      </div>
      <div
        v-for="(_, index) in model.rejected_quantity"
        :key="index"
        class="px-3"
      >
        <div class="row">
          <div
            class="row py-3 mb-4 shadow-sm col-11"
            style="border: 0.5px solid #6ba6524d"
          >
            <div class="col-12 col-sm-8 col-lg-10">
              <fg-input
                :label="`${$t('sowing.reason_rejection')} ${index + 1}: *`"
                class="required-name"
                ref="name"
                type="text"
                v-model="model.cause_rejected_name[index]"
                :name="`production.cause_rejected_${index}`"
                v-validate="modelValidations.cause_rejected_name"
                :error="
                  getFieldErrorByIndex('sowing.reason_rejection', true, index)
                "
                placeholder="..."
                @blur="
                  convertUppercase(model.cause_rejected_name[index], index)
                "
              ></fg-input>
            </div>
            <div class="col-12 col-sm-4 col-lg-2">
              <div class="form-group has-label">
                <label>{{ $t('common_words.status') }}</label>
                <el-switch
                  v-model="model.rejected_status[index]"
                  style="display: block; margin-top: 0.5rem"
                  active-color="#6BA652"
                  inactive-color="#ff4949"
                >
                </el-switch>
              </div>
            </div>
          </div>
          <!-- Botones de acción por fila -->
          <div
            class="col-1 col-sm-4 col-lg-1 d-flex justify-content-center align-items-center"
          >
            <div class="btn-group" role="group">
              <button
                class="btn btn-danger custom-shadow-btn mr-2"
                @click.prevent="
                  handleDelete(index, model.cause_rejected_name[index])
                "
              >
                <em class="fa fa-minus"></em>
              </button>

              <button
                v-if="index === model.rejected_quantity - 1"
                class="btn btn-success custom-shadow-btn"
                @click.prevent="addRow"
              >
                <em class="fa fa-plus"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset, convertFirstLetterUppercase } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import { MixinExport } from 'src/mixins/mixin-export';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        cause_rejected_id: [],
        cause_rejected_name: [''],
        rejected_status: [true],
        rejected_quantity: 1,
      },
      modelValidations: {
        cause_rejected_name: {
          required: false,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinExport, MixinForm, MixinValidations],
  methods: {
    convertUppercase(value, index) {
      const motiveName = value;
      const name = convertFirstLetterUppercase(motiveName);
      this.model.cause_rejected_name[index] = name;
    },

    // Agregar nueva fila
    addRow() {
      this.model.cause_rejected_name.push('');
      this.model.rejected_status.push(true);
      this.model.cause_rejected_id.push(null);
      this.model.rejected_quantity++;
    },

    handleDelete(index, name) {
      if (name) {
        SweetAlert.delete(name).then((result) => {
          if (result.value) this.removeRow(index);
        });
      } else {
        this.removeRow(index);
      }
    },

    // Eliminar fila específica
    removeRow(index) {
      if (this.model.rejected_quantity > 1) {
        this.model.cause_rejected_name.splice(index, 1);
        this.model.rejected_status.splice(index, 1);
        this.model.cause_rejected_id.splice(index, 1);
        this.model.rejected_quantity--;
      } else {
        // Evita que se elimine la última fila
        this.model.cause_rejected_name = [''];
        this.model.rejected_status = [true];
        this.model.cause_rejected_id = [null];
        this.model.rejected_quantity = 1;
      }
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        const ids = this.model.cause_rejected_id || [];
        const names = this.model.cause_rejected_name || [];
        const statuses = this.model.rejected_status || [];

        const cleanIds = [];
        const cleanNames = [];
        const cleanStatuses = [];

        for (let i = 0; i < this.model.rejected_quantity; i++) {
          const name = names[i];

          if (!isset(name) || String(name).trim() === '') {
            continue;
          }

          cleanIds.push(ids[i] ? ids[i] : null);
          cleanNames.push(String(name).trim());
          cleanStatuses.push(statuses[i]);
        }

        if (cleanNames.length === 0) {
          this.$emit('on-validated', {
            ...this.model,
            cause_rejected_id: [],
            cause_rejected_name: [],
            rejected_status: [],
            rejected_quantity: 0,
          });

          return true;
        }

        this.$emit('on-validated', {
          ...this.model,
          cause_rejected_id: cleanIds,
          cause_rejected_name: cleanNames,
          rejected_status: cleanStatuses,
          rejected_quantity: cleanNames.length,
        });

        return res;
      });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));

      const { cause_rejected_clusters } = editForm;

      if (!cause_rejected_clusters || !cause_rejected_clusters.length) {
        return;
      }

      this.model = {
        isEdit: true,
        cause_rejected_id: [],
        cause_rejected_name: [],
        rejected_status: [],
        rejected_quantity: cause_rejected_clusters.length,
      };

      cause_rejected_clusters.forEach(({ id, name, deleted_at }) => {
        this.model.cause_rejected_id.push(id);
        this.model.cause_rejected_name.push(name);
        this.model.rejected_status.push(!deleted_at);
      });
    }
  },
};
</script>
